/** Roles that use school-wide student lists (ignore admin.class_ scoping). */
export const FINANCE_FULL_STUDENT_ACCESS_ROLES = Object.freeze([
  'Accountant',
  'Finance Officer',
]);

function titleIndicatesFinanceRole(positiondescription) {
  if (positiondescription == null || positiondescription === '') return false;
  const normalized = String(positiondescription).trim().toLowerCase();
  if (
    FINANCE_FULL_STUDENT_ACCESS_ROLES.some((role) => role.toLowerCase() === normalized)
  ) {
    return true;
  }
  return (
    normalized.includes('accountant') || normalized.includes('finance officer')
  );
}

function truthyAlsoAccountant(value) {
  return value === true || value === 'true' || value === 1 || value === '1';
}

/**
 * School-wide student/canteen/fees access.
 * Pass the logged-in `admin` object (recommended), or a `positiondescription` string.
 */
export function hasFinanceFullStudentAccess(adminOrPositionDescription) {
  if (
    adminOrPositionDescription != null &&
    typeof adminOrPositionDescription === 'object' &&
    !Array.isArray(adminOrPositionDescription)
  ) {
    const admin = adminOrPositionDescription;
    if (truthyAlsoAccountant(admin.alsoAccountant)) return true;
    return titleIndicatesFinanceRole(admin.positiondescription);
  }
  return titleIndicatesFinanceRole(adminOrPositionDescription);
}
